import React, { useState, useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import {
  sortTime,
  fixLineData,
  sortArr,
  sortStr,
  sortStr2,
  computeMobileTopPrecent,
} from '@/pages/intelligence/pages/MarketProfile/_util';
import {
  mapColor,
  segmentOptionsMobile,
  lineColor,
  getSortType,
} from '@/pages/intelligence/pages/MarketProfile/_config/Const';
import useDataSearchHook from '@/pages/intelligence/pages/MarketProfile/hooks/useDataSearchHook';

// 测试数据导入
import {
  pcConsoleFixData,
  getPCConsoleMarkets,
} from '@/pages/intelligence/pages/MarketProfile/_config/_testData';
import { getMarketProfileFilterMarket } from '@/pages/intelligence/services/marketProfile';
import moment from 'moment';

export default function useMobileGameModel(props: any) {
  const {
    pageId,
    changeSelectDate,
    selectDate = [],
    selectMainGenre = [],
    selectSubGenres = [],
    changesetSelectGenre,
    regionValue,
    changeRegionSelect,
    defaultYear,
  } = props;

  // 筛选条件参数
  const [time, setTime] = useState(['', '']);
  const [yearData, setYearData] = useState(`in ${defaultYear}`);
  // 原本写死的2022，改为当前年往前推1年
  const [annualOptionsValue, setAnnualOptionsValue] = useState(defaultYear);

  // 地图参数
  // 地图数据，mapData1---选项1的数据，mapData2---选项2的数据，mapData3---选项Total Revenue的数据，mapData4---选项Total Players的数据
  const [mapData1, setMapData1] = useState([]);
  const [mapData2, setMapData2] = useState([]);
  const [mapData3, setMapData3] = useState([]);
  const [mapData4, setMapData4] = useState([]);

  const [mainSegment, setMainSegment] = useState('Revenue');

  // mobileGame top 数据
  const [globelData, setGlobelData] = useState<any>({});
  const [androidData, setAndroidData] = useState({});
  const [iosData, setIosData] = useState({});
  const [dataState, setDataState] = useState(0);
  const [regionValueNew, setRegionValue] = useState(regionValue);
  const [dataSourceValue, setDataSourceValue] = useState('sensortower');
  const [mainGenreValue, setMainGenreValue] = useState(['All']);
  // 表格table参数等
  // table加载状态：1---加载完毕，有数据；0---加载中；2--加载完毕，但无数据
  const [tableState, setTableState] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);
  // 表格展示的数据
  const [showTableData, setShowTableData] = useState([]);
  const [marketTableData, setMarketTableData] = useState([]);
  // 表格所有的数据，用于筛选、排序等，不用再次调用接口
  const [allTableData, setAllTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [pageSize, setPageSize] = useState(100);
  const [pageIndex, setPageIndex] = useState(1);
  const [sortColunms, setSortColunms] = useState(['revenue']);
  // 国家筛选器接口值
  const [countrySet, setCountrySet] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState<string[]>([]);
  const [allMarkets, setAllMarkets] = useState([]);
  const pageIdType = {
    MarketProfilMobile: 'mobile',
    MarketProfilPC: 'pc',
    MarketProfilConsole: 'console',
    MarketProfilAnnualReport: 'annal_report',
  } as any;

  const [mobileParams, setMobileParams] = useState({
    start_date: '',
    end_date: '',
    granularity: 'monthly',
    source_metrics: {
      appannie: ['revenue', 'download', 'game_count'],
      sensortower: ['revenue', 'download', 'game_count'],
    },
    region_type: 'market',
    regions: [],
    metrics: ['revenue', 'download', 'game_count'],
    genres: ['All'],
    Platforms: [],
    b_group_by_region: false,
    b_group_by_date: false,
    b_growth_ratio: true,
    b_group_by_platform: true,
    b_group_by_genre: false,
  });

  const [region, setRegion] = useState({
    region_type: 'market',
    regions: ['global'],
    realMarkets: [],
    markets: ['global'],
  });

  // 用于搜索的所有国家筛选内容
  const [allSearchMarketsList, setAllSearchMarketsList] = useState([]);
  // 用于搜索的国家筛选内容
  const [selectSearchMarketList, setSelectSearchMarketList] = useState([]);

  const [searchKeyWord, setSearchKeyWord] = useState([]);

  //
  const [chartType, setChartType] = useState('chart-map');
  const [selectedKeysColor, setSelectedKeysColor] = useState({});
  //
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectAllKeys, setSelectAllKeys] = useState([]);

  const [lineTrendData, setLineTrendData] = useState({});
  const genreRef = useRef(null);
  const [mainGenres, setMainGenres] = useState(selectMainGenre);
  const [subGenres, setSubGenres] = useState(selectSubGenres);

  const [ieggGenre, setIeggGenre] = useState([]);
  const [annualYearSummary, setAnnualYearSummary] = useState<any>({});

  // 数据排序，筛选 提取
  const filterData = (keyword: any, type = sortColunms[0]) => {
    setTableState(0);
    const sortM = getSortType(type, pageId);

    let data = [];
    if (type === 'totalRevenue' || type === 'totalPlayer') {
      // data = allTableData.sort(sortStr(sortM));
      data = marketTableData.sort(sortStr(sortM));
    } else {
      // data = allTableData.sort(sortArr(sortM));
      data = marketTableData.sort(sortArr(sortM));
    }
    if (keyword != '') {
      data = data.filter((item: any) => {
        return item.marketName.indexOf(keyword) != -1;
      });
      // pageOperationLog(true, false, keyword, '', ''); ?打点
    } else {
      let rankNum = 0;
      data.map((item: any) => {
        // item['rank'] = index + 1
        let tempRank;
        if (item.marketNameEn == 'global') {
          tempRank = '-';
        } else if (item.marketNameEn == 'global_wo_china') {
          tempRank = '- ';
        } else {
          rankNum += 1;
          tempRank = rankNum;
        }
        item.rank = tempRank;
      });
    }

    const selectedKeysTemp = [] as any;
    const selectedKeysColorTemp = {} as any;

    const globalData = [] as any;
    const otherData = [] as any;
    data.forEach((item: any) => {
      if (selectedKeysTemp.length < 6 && item.marketNameEn !== 'global' && item.marketNameEn !== 'global_wo_china') {
        selectedKeysColorTemp[item.marketName] = lineColor[selectedKeysTemp.length];
        // selectedKeysTemp.push(item['marketName']);
        selectedKeysTemp.push({
          gameId: item.marketName,
          color: lineColor[selectedKeysTemp.length],
          marketEn: item.marketNameEn,
        });
      }
      if (item.marketNameEn != 'global' && item.marketNameEn != 'global_wo_china') {
        otherData.push(item);
      } else {
        globalData.push(item);
      }
    });
    globalData.sort(sortStr2('marketNameEn'));
    const showDataTemp = globalData.concat(otherData);

    setSelectedKeys(selectedKeysTemp);
    setSelectAllKeys(selectedKeysTemp);
    setSelectedKeysColor(selectedKeysColorTemp);
    setShowTableData(showDataTemp);
    if (showDataTemp.length != 0) {
      setTableState(1);
    } else {
      setTableState(2);
    }
  };

  const { dataSearch } = useDataSearchHook({
    pageId,
    setTableState,
    setTableLoading,
    setDataState,
    setLineTrendData,
    setSelectedKeys,
    setSelectAllKeys,
    setSelectedKeysColor,
    setGlobelData,
    setAndroidData,
    setIosData,
    mapData1,
    mapData2,
    mapData3,
    mapData4,
    setMapData1,
    setMapData2,
    setMapData3,
    setMapData4,
    setShowTableData,
    showTableData,
    setAllTableData,
    allTableData,
    setMarketTableData,
    marketTableData,
    setSelectedMarket,
    selectedMarket,
    allMarkets,
    searchKeyWord,
    setTime,
    time,
    mainSegment,
    setAnnualYearSummary,
    filterData,
    yearData,
    setYearData,
    changeSelectDate,
    selectDate,
  });

  const getContryList = async () => {
    const entity_type = pageIdType[pageId];
    try {
      const result = await getMarketProfileFilterMarket({
        entity_type,
        regions: entity_type === 'pc' || entity_type === 'console' ? getPCConsoleMarkets() : [],
      });
      const regionCountryList = result?.region_country || [];
      setCountrySet(regionCountryList);
      const markets = [] as any;
      const countryData = [] as any;
      regionCountryList?.forEach((item: any) => {
        item?.country_set?.forEach((t: any) => {
          markets.push(t?.abbre);
          countryData.push({
            name: t?.name == 'Congo' ? 'Republic of the Congo' : t?.name,
            enName: t?.abbre,
          });
        });
      });
      // 筛选后搜索国家的列表
      setSelectSearchMarketList(countryData);
      // 全部搜索国家的列表
      setAllSearchMarketsList(countryData);

      setAllMarkets(markets);
      // 默认全选国家
      setSelectedMarket(markets);
    } catch (err) {
      console.log('err', err);
    }
  };

  const onMarketSelectorChange = (value: string[]) => {
    setSelectedMarket(value);
  };
  const onConfirmMarketSelector = (mrk: any[]) => {
    const sMarkets = mrk || selectedMarket;
    if (sMarkets?.length === 0) {
      // 全取消则展示全部表格数据， 如果有搜索内容，只展示搜索内容
      setMarketTableData(allTableData);
      // setSelectedMarket(allMarkets);
      setSelectSearchMarketList(allSearchMarketsList);
      return;
    }
    const _marketTableData = allTableData.filter((item: any) => {
      return sMarkets.includes(item?.marketNameEn);
    });

    setShowTableData(_marketTableData);
    setMarketTableData(_marketTableData);

    // 同步用于搜索列表的国家内容
    const _selectSearchMarkets = allSearchMarketsList.filter((item: any) => {
      return sMarkets.includes(item?.enName);
    });
    setSelectSearchMarketList(_selectSearchMarkets);
  };

  useEffect(() => {
    if (marketTableData.length > 0) {
      setTableState(1);
      filterData(searchKeyWord?.length > 0 ? searchKeyWord[0] : '', sortColunms[0]);
    }
  }, [JSON.stringify(marketTableData)]);

  const changeMpTableSort = (type: any) => {
    if (sortColunms[0] != type) {
      sortColunms.length = 0;
      sortColunms.push(...[`${type}`]);
      setSortColunms(sortColunms);
      // getTableColumns();
      filterData(searchKeyWord?.length > 0 ? searchKeyWord[0] : '', sortColunms[0]);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    const entity_type =
      pageId == 'MarketProfilMobile' ? 'mobile' : pageId == 'MarketProfilPC' ? 'pc' : 'console';
    const endTime = selectDate[1]
      ? moment(selectDate[1]).startOf('month').subtract(-1, 'month').format('YYYY-MM-DD')
      : '';
    const iegg_genre_req: any = dealGenreToParams(selectMainGenre, selectSubGenres);
    const region = ['MarketProfilPC', 'MarketProfilConsole'].includes(pageId)
      ? { region_type: 'market', regions: regionValue?.markets || ['global'] }
      : {};
    // const params =
    //   pageId == 'MarketProfilAnnualReport'
    //     ? { year: `${annualOptionsValue}` }
    //     : {
    //         entity_type,
    //         start_date: selectDate[0],
    //         end_date: endTime,
    //         genre: [],
    //         sub_genre: [],
    //         iegg_genre_req,
    //         ...region,
    //       };
    let params = {};
    if (pageId === 'MarketProfilAnnualReport') {
      params = { year: `${annualOptionsValue}` };
    } else if (pageId === 'MarketProfilMobile') {
      params = mobileParams;
    } else {
      params = {
        entity_type,
        start_date: selectDate[0],
        end_date: endTime,
        genre: [],
        sub_genre: [],
        iegg_genre_req,
        ...region,
      };
    }
    // console.log('pageIdpageIdpageId', pageId);
    dataSearch(params, true);
    // getGenreList();
    resetSort();
    // 获取国家筛选器列表
    getContryList();

    localStorage.setItem(
      'mpMapSerieName',
      pageId == 'MarketProfilMobile' || pageId == 'MarketProfilAnnualReport'
        ? 'Revenue'
        : 'Digital',
    );

    localStorage.setItem('genreSourceTemp', pageId == 'MarketProfilMobile' ? 'annie' : 'iegg');

    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  useEffect(() => {
    setPageIndex(1);
  }, [showTableData]);

  const resetSort = () => {
    if (pageId == 'MarketProfilMobile') {
      setMainSegment('Revenue');
      sortColunms.length = 0;
      sortColunms.push(...['revenue']);
      setSortColunms(sortColunms);
    } else if (pageId == 'MarketProfilPC' || pageId == 'MarketProfilConsole') {
      setMainSegment('Digital');
      sortColunms.length = 0;
      sortColunms.push(...['digital']);
      setSortColunms(sortColunms);
    } else if (pageId == 'MarketProfilAnnualReport') {
      sortColunms.length = 0;
      sortColunms.push(...['annualRevenue']);
      setSortColunms(sortColunms);
    }
    // getTableColumns();
  };

  // 地图数据重新渲染
  const onSegmentChange = (value: string) => {
    setMainSegment(value);
    // localStorage.setItem('mpMapSerieName', value);
    // if (chartType == 'discount-chart') {
    //   drawLine(value);
    // } else {
    //   if (value == 'Revenue' || value == 'Digital') {
    //     refreshMapData('mpGameMap' + pageId, mapData1);
    //   } else if (value == 'Downloads' || value == 'Physical') {
    //     refreshMapData('mpGameMap' + pageId, mapData2);
    //   } else if (value == 'TotalRevenue') {
    //     refreshMapData('mpGameMap' + pageId, mapData3);
    //   } else if (value == 'TotalPlayer') {
    //     refreshMapData('mpGameMap' + pageId, mapData4);
    //   }
    // }
  };

  // 改变图表类型
  const changeChartType = (icon: any) => {
    // console.log('typetype',type);
    setChartType(icon);
    // let value = localStorage.getItem('mpMapSerieName');
    // if (icon == 'chart-map') {
    //   let mapData = [] as any;
    //   if (value == 'Revenue' || value == 'Digital') {
    //     mapData = mapData1;
    //   } else if (value == 'Downloads' || value == 'Physical') {
    //     mapData = mapData2;
    //   } else if (value == 'TotalRevenue') {
    //     mapData = mapData3;
    //   } else if (value == 'TotalPlayer') {
    //     mapData = mapData4;
    //   }
    //   worldMapExample(mapData, 'mpGameMap' + pageId, mapColor);
    // } else if (icon == 'discount-chart' && selectedKeys.length > 0) {
    //   drawLine(mainSegment);
    // }
  };

  // 窗口变化调整布局 提取
  const resizeHandler = () => {
    const mapDom = document.getElementById(`mpGameMap${pageId}`);
    if (mapDom) {
      const mapChart = echarts.init(mapDom);
      try {
        mapChart.resize();
      } catch (e) {}
    }

    const lineDom = document.getElementById('mpAnnualSummaryCharts');
    if (lineDom) {
      const lineChart = echarts.init(lineDom);
      try {
        lineChart.resize();
      } catch (e) {}
    }
  };

  // 获取时间的开始和结束时间
  // @ts-ignore
  const onChangeRangePicker = async (Date, type, siderTab) => {
    changeSelectDate([moment(Date[0]).format('YYYY-MM-DD'), moment(Date[1]).format('YYYY-MM-DD')]);
    setTime([moment(Date[0]).format('YYYY-MM-DD'), moment(Date[1]).format('YYYY-MM-DD')]);

    const endYear = Number(moment(Date[1]).format('YYYY-MM-DD').slice(0, 4));
    const startYear = Number(moment(Date[0]).format('YYYY-MM-DD').slice(0, 4));
    const endTime = Date[1].startOf('month').subtract(-1, 'month').format('YYYY-MM-DD');

    // pc/console Newzoo年份展示
    let showYear = '';
    if (startYear === endYear) {
      showYear = `in ${startYear}`;
      setYearData(`in ${startYear}`);
    } else {
      showYear = `Sum of ${startYear}-${endYear}`;
      setYearData(`Sum of ${startYear}-${endYear}`);
    }

    const params = {
      entity_type:
        pageId == 'MarketProfilMobile' ? 'mobile' : pageId == 'MarketProfilPC' ? 'pc' : 'console',
      start_date: moment(Date[0]).format('YYYY-MM-DD'),
      end_date: endTime,
      // genre: genreMain,
      // sub_genre: genreSub,
      iegg_genre_req: ieggGenre,
      ...(['MarketProfilPC', 'MarketProfilConsole'].includes(pageId)
        ? { region_type: 'market', regions: region?.markets || ['global'] }
        : {}),
    };
    await dataSearch(params, false);
    if (selectedMarket?.length) {
      onConfirmMarketSelector(selectedMarket);
    }
  };

  /** pc/console地域筛选器变化 */
  const onRegionChange = (regionData: any) => {
    const startTime = selectDate[0];
    const endDate = selectDate[1];
    const endTime = moment(endDate).startOf('month').subtract(-1, 'month').format('YYYY-MM-DD');
    const params = {
      entity_type: pageId == 'MarketProfilPC' ? 'pc' : 'console',
      iegg_genre_req: ieggGenre,
      start_date: startTime,
      end_date: endTime,
      regions: regionData?.markets || ['global'],
      region_type: 'market',
    };
    setRegion(regionData);
    changeRegionSelect(regionData);
    dataSearch(params, false);
  };

  const dealGenreToParams = (mainGenres: any, subGenres: any) => {
    const iegg_genre_req: any = [];
    if (mainGenres?.length > 0) {
      mainGenres.forEach((item: any, index: any) => {
        const obj = {
          value: item.value,
          relation: item.relation,
          children: [],
        };
        const cTemp: any = [];
        if (!item.checked) {
          subGenres
            ?.filter((k: any) => {
              return item.value == k.parentValue;
            })
            .map((oo: any, index: any) => {
              cTemp.push({ value: oo.value });
            });
          obj.children = cTemp;
        }
        iegg_genre_req.push(obj);
      });
    }
    setIeggGenre(iegg_genre_req);
    return iegg_genre_req || [];
  };

  // 品类筛选改变值 重新请求数据
  const pcGenreChange = (payload: any) => {
    // const { mainGenres, subGenres } = payload;
    changesetSelectGenre(payload);
    // setMainGenres(mainGenres);
    // setSubGenres(subGenres);
    // const iegg_genre_req: any = dealGenreToParams(mainGenres, subGenres);
    const startTime = selectDate[0];
    const endDate = selectDate[1];
    const endTime = moment(endDate).startOf('month').subtract(-1, 'month').format('YYYY-MM-DD');

    const params = {
      entity_type:
        pageId == 'MarketProfilMobile' ? 'mobile' : pageId == 'MarketProfilPC' ? 'pc' : 'console',
      start_date: startTime,
      end_date: endTime,
      // genre: genreMainTemp,
      // sub_genre: genreSubTemp,
      // iegg_genre_req,
      // ...(['MarketProfilPC', 'MarketProfilConsole'].includes(pageId)
      //   ? { region_type: 'market', regions: region?.markets || ['global'] }
      //   : {}),
    };
    // setIeggGenre(iegg_genre_req);
    // setGenreMain(genreMainTemp);
    // setGenreSub(genreSubTemp);

    dataSearch(params, false);
  };

  // 品类筛选改变值 重新请求数据
  const mainGenreChange = (payload: any) => {
    const { mainGenres, subGenres } = payload;
    changesetSelectGenre(payload);
    setMainGenres(mainGenres);
    setSubGenres(subGenres);
    const iegg_genre_req: any = dealGenreToParams(mainGenres, subGenres);
    const startTime = selectDate[0];
    const endDate = selectDate[1];
    const endTime = moment(endDate).startOf('month').subtract(-1, 'month').format('YYYY-MM-DD');

    const params = {
      entity_type:
        pageId == 'MarketProfilMobile' ? 'mobile' : pageId == 'MarketProfilPC' ? 'pc' : 'console',
      start_date: startTime,
      end_date: endTime,
      // genre: genreMainTemp,
      // sub_genre: genreSubTemp,
      iegg_genre_req,
      ...(['MarketProfilPC', 'MarketProfilConsole'].includes(pageId)
        ? { region_type: 'market', regions: region?.markets || ['global'] }
        : {}),
    };
    setIeggGenre(iegg_genre_req);

    dataSearch(params, false);
  };

  // 数据源筛选改变值 重新请求数据
  const dataSourceChange = (payload: any) => {
    const { mainGenres, subGenres } = payload;
    changesetSelectGenre(payload);
    setMainGenres(mainGenres);
    setSubGenres(subGenres);
    const iegg_genre_req: any = dealGenreToParams(mainGenres, subGenres);
    const startTime = selectDate[0];
    const endDate = selectDate[1];
    const endTime = moment(endDate).startOf('month').subtract(-1, 'month').format('YYYY-MM-DD');

    const params = {
      entity_type:
        pageId == 'MarketProfilMobile' ? 'mobile' : pageId == 'MarketProfilPC' ? 'pc' : 'console',
      start_date: startTime,
      end_date: endTime,
      iegg_genre_req,
      ...(['MarketProfilPC', 'MarketProfilConsole'].includes(pageId)
        ? { region_type: 'market', regions: region?.markets || ['global'] }
        : {}),
    };
    setIeggGenre(iegg_genre_req);

    dataSearch(params, false);
  };

  const changeMarketProfileAll = (params: any) => {
    if (params.type === 'cancel') {
      setSelectedKeys([]);
      // setSelectedKeysColor({});
      changeChartType('discount-chart');
    } else {
      const checknoColor = {} as any;
      selectAllKeys.map((item, index) => {
        checknoColor[item] = lineColor[index];
      });
      setSelectedKeysColor(checknoColor);
      setSelectedKeys(selectAllKeys);
      changeChartType('discount-chart');
    }
  };

  return {
    region,
    dataSearch,
    showTableData,
    sortColunms,
    globelData,
    time, // 时间
    androidData,
    iosData,
    mainSegment,
    onSegmentChange,
    changeChartType,
    changeMarketProfileAll,
    selectedKeys,
    selectAllKeys,
    selectedKeysColor,
    setSelectedKeys,
    setSelectedKeysColor,
    chartType,
    setChartType,
    tableLoading,
    onChangeRangePicker,
    pcGenreChange,
    mainGenreChange,
    dataSourceChange,
    onRegionChange,
    mainGenres,
    subGenres,
    ieggGenre,
    countrySet,
    selectedMarket,
    onMarketSelectorChange,
    onConfirmMarketSelector,
    selectSearchMarketList,
    allSearchMarketsList,
    setSearchKeyWord,
    searchKeyWord,
    filterData,
    changeMpTableSort,
    yearData,
    annualOptionsValue,
    annualYearSummary,
    setAnnualOptionsValue,
    mapData1,
    mapData2,
    mapData3,
    mapData4,
    lineTrendData,
    regionValueNew,
    setRegionValue,
    setDataSourceValue,
    dataSourceValue,
    mainGenreValue,
    setMainGenreValue,
  };
}
